import { ARRAY_CONSTRUCTOR_TO_TYPE, IS_BIGINT_ARRAY, TYPED_ARRAY_LABEL } from "./marshalTypedArrayTypes";

/**
 * Replaces all typed arrays with object's that can be properly transformed into JSON
 */
export function marshalTypedArraysInObject(object: object): object {
  if (object === null || object === undefined) {
    return object;
  }

  if (typeof object === "object") {
    if (ArrayBuffer.isView(object)) {
      return marshalTypedArray(object);
    }

    if (Array.isArray(object)) {
      return object.map(marshalTypedArraysInObject);
    }

    const dst: { [key: string]: any } = {};
    for (const key in object) {
      if ((object as Record<string, any>).hasOwnProperty(key)) {
        dst[key] = marshalTypedArraysInObject((object as Record<string, any>)[key]);
      }
    }

    return dst;
  }

  return object;
}

export function marshalTypedArray(object: ArrayBufferView): object {
  // Get the constructor name
  const constructorName = object.constructor.name;

  // Lookup the type from the constructor map
  const type = ARRAY_CONSTRUCTOR_TO_TYPE[constructorName];

  if (!type) {
    throw new Error(`Unknown typed array type: ${constructorName}`);
  }

  // JSON stringify doesn't support BigInt values, so we need to convert them to strings
  return {
    [TYPED_ARRAY_LABEL]: type,
    values: IS_BIGINT_ARRAY[type]
      ? Array.from(object as any).map((value) => (value as BigInt).toString())
      : Array.from(object as any),
  };
}
